import React from 'react';

export const Skeleton: React.FC<{ h?: number | string; w?: number | string; r?: number; style?: React.CSSProperties }> = ({
  h = 16,
  w = '100%',
  r,
  style,
}) => <div className="v2-skel" style={{ height: h, width: w, borderRadius: r, ...style }} aria-hidden />;

export const RowsSkeleton: React.FC<{ rows?: number }> = ({ rows = 3 }) => (
  <div className="v2-list" aria-busy>
    {Array.from({ length: rows }).map((_, i) => (
      <div className="v2-row" key={i}>
        <Skeleton w={52} h={52} r={13} />
        <div className="v2-row-body v2-stack" style={{ gap: 8 }}>
          <Skeleton w="40%" h={14} />
          <Skeleton w="24%" h={12} />
        </div>
      </div>
    ))}
  </div>
);

export const GridSkeleton: React.FC<{ count?: number; className?: string }> = ({ count = 6, className = 'v2-grid' }) => (
  <div className={className} aria-busy>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="v2-media v2-skel" />
    ))}
  </div>
);
